import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useState, useEffect } from "react";
import {
    Container,
    CardBody,
    Card,
} from "reactstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";




const SellerProfile = () => {
    document.title = "Seller Profile | BuyPass";
    const selectuserProfile = createSelector(
        (state: any) => state.Business,
        (business) => business?.business
    );
    const seller = useSelector(selectuserProfile);

    useEffect(() => {
    }, [seller]);

    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );
    const user = useSelector(selectUser);
    useEffect(() => {
    }, [user]);
    return (
        <div className="page-content seller-profile">
            <Container fluid>

                <BreadCrumb title=" Seller Profile" pageTitle="My-Account"  pageTitleRoute="/my-account-setting" />
                <Card>
                    <CardBody className="rounded-3">
                        <div className="d-grid gap-3" >
                            <div >
                                <h6 className="fw-bold ">Seller ID</h6>
                                <p className="m-0 p-0">{seller?.buypassId || '--'}</p> 
                            </div>
                            <div >
                                <h6 className="fw-bold ">First Name<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.firstName || seller?.fullName || '--'}
                                    {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                </p>
                            </div>
                            <div >
                                <h6 className="fw-bold ">Contact Email address <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.email?? user?.email?? "--" }
                                    {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                </p>
                            </div>
                            <div >
                                <h6 className="fw-bold ">Contact Mobile Phone Number <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.phoneNumber || '--'}
                                    {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                </p>
                            </div>
                            <div >
                                <h6 className="fw-bold ">Display Name / Shop Name<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">{seller?.storeName || '--'}
                                    {/* <span className="text-success cursor-pointer ms-2">Modify</span> */}
                                </p>
                            </div>

                            <div >
                            <h6 className="fw-bold">Shop Logo
                            <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span>
                                </h6>
                                <p className="m-0 p-0">
                                    {seller?.shopLogo?.url ? (
                                    <img src={seller?.shopLogo?.url} alt="Shop Logo" style={{ width: '100px', height: 'auto' }} />
                                    ) : (
                                    '--'
                                    )}
                    </p>
                            </div>

                            <div className="seller-timings">
                                {seller?.timings?.length > 0 ? (
                                    seller.timings.map((timing: any, index: number) => (
                                    <p key={index} className="m-0 p-0">
                                        <strong>
                                        {timing?.day?.charAt(0).toUpperCase() + timing?.day?.slice(1)}:
                                        </strong>{" "}
                                        {timing?.isOpen ? (
                                        timing?.slotsTiming && timing?.slotsTiming.length > 0 ? (
                                            timing?.slotsTiming.map((slot: any, slotIndex: number) => (
                                            <span key={slotIndex} style={{ color: "black" }}>
                                                {slot.startTime} - {slot.endTime}
                                                {slotIndex !== timing?.slotsTiming.length - 1 && ", "}
                                            </span>
                                            ))
                                        ) : (
                                            <span style={{ color: "gray" }}>No slots available</span>
                                        )
                                        ) : (
                                        <span style={{ color: "red" }}>Closed</span>
                                        )}
                                    </p>
                                    ))
                                ) : (
                                    <p>No timings available</p>
                                )}
                                </div>






                            
                            <div>
                                <h6 className="fw-bold">
                                    Holiday Mode
                                    <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span>
                                </h6>
                                <p className="m-0 p-0">
                                    {seller?.holiday?.holidayMode ? "on" : "off"}
                                </p>
                            </div>


                                  <div>
                                {/* <h6 className="fw-bold">Address <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6> */}
                                <p className="m-0 p-0">
                                {
                                            // seller?.idBankDetails?.isBusinessAddressSame
                                                 seller?.address?.streetAddress || "--"
                                                // : seller?.idBankDetails?.businessAddress?.streetAddress || "--"
                                        }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">State <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        // seller?.idBankDetails?.isBusinessAddressSame
                                             seller?.address?.state || "--"
                                            // : seller?.idBankDetails?.businessAddress?.state || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">City <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        // seller?.idBankDetails?.isBusinessAddressSame
                                             seller?.address?.city || "--"
                                            // : seller?.idBankDetails?.businessAddress?.city || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Neighborhood <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        // seller?.idBankDetails?.isBusinessAddressSame
                                            // ?
                                             seller?.address?.neighborhood || "--"
                                            // : seller?.idBankDetails?.businessAddress?.neighborhood || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Plaza Market Name <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        // seller?.idBankDetails?.isBusinessAddressSame
                                            // ?
                                             seller?.address?.plazaMarketName || "--"
                                            // : seller?.idBankDetails?.businessAddress?.plazaMarketName || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Shop Name <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        // seller?.idBankDetails?.isBusinessAddressSame
                                            // ?
                                             seller?.address?.shopName || "--"
                                            // : seller?.idBankDetails?.businessAddress?.shopName || "--"
                                    }
                                </p>
                            </div>

                            <div>
                                <h6 className="fw-bold">Shop Number <span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">
                                    {
                                        // seller?.idBankDetails?.isBusinessAddressSame
                                            // ? 
                                            seller?.address?.shopNumber || "--"
                                            // : seller?.idBankDetails?.businessAddress?.shopNumber || "--"
                                    }
                                </p>
                            </div>
                           

                            {/* <div >
                                <h6 className="fw-bold ">Holiday Mode Period<span><i className="ri-information-line ms-2 fs-5 fw-normal"></i></span></h6>
                                <p className="m-0 p-0">--</p>
                            </div> */}
                        </div>
                        {/* <div className="w-100 text-center">
                            <div className="border border-2 mx-auto rounded-pill d-flex justify-content-center align-items-center text-black-50 cursor-pointer fw-bold" style={{ width: '120px', height: "40px" }}>Show More <span className="ms-1 fs-4"><i className="ri-arrow-down-s-line"></i></span></div>
                        </div> */}
                    </CardBody>
                </Card>
                <Card>
                    <CardBody className="rounded-3 text-end">
                        <Link to="/seller-profile-modify" className="  ">
                            <button type="button" className="btn btn-secondary" data-testing-Id="modifyButton_sellerProfile">Modify</button>
                        </Link>

                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default SellerProfile;
